export default __webpack_public_path__ + "static/commmune_communitymarketing_3merits-fe46b7f68c7063d473f46c645bf86cf3.jpg";